import React, { useState } from 'react';
import { Row, Col, Tooltip } from 'reactstrap';
import { FaEnvelope, FaDiscord, FaTwitter, FaCopy, FaShare } from 'react-icons/fa';

function Contact() {
  const [tooltipOpen, setTooltipOpen] = useState({
    'contact@wattsonx.com': false,
    notwatty: false,
    '@wattson__x': false,
  });

  const [copyStatus, setCopyStatus] = useState({
    'contact@wattsonx.com': 'Copy email!',
    notwatty: 'Copy discord!',
    '@wattson__x': 'Go there!',
  });

  const ToolTipText = {
    'contact@wattsonx.com': { uncliked: 'Copy email!', clicked: 'Copied email!' },
    notwatty: { uncliked: 'Copy discord!', clicked: 'Copied discord!' },
    '@wattson__x': { uncliked: 'Go there!', clicked: 'Redirecting you!' },
  };

  const toggleTooltip = referer => {
    setTooltipOpen(prevState => ({
      ...prevState,
      [referer]: !prevState[referer],
    }));
  };

  const copyText = referer => {
    navigator.clipboard.writeText(referer);
    setCopyStatus(prevState => ({
      ...prevState,
      [referer]: ToolTipText[referer]['clicked'],
    }));

    setTimeout(() => {
      setCopyStatus(prevState => ({
        ...prevState,
        [referer]: ToolTipText[referer]['uncliked'],
      }));
    }, 2000);
  };

  return (
    <Row>
      <Col>
        <h2>Interested in working together?</h2>
        <strong>
          <h3>Contact Me</h3>
        </strong>
        <p onFocus={e => e.target.blur()}>
          {/* Email */}
          <span style={{ cursor: 'pointer' }}>
            <FaEnvelope /> Email: contact@wattsonx.com &nbsp;
            <FaCopy
              style={{ cursor: 'pointer' }}
              onClick={() => copyText('contact@wattsonx.com')}
              id="emailCopy"
              className="text-muted"
              onMouseEnter={() => toggleTooltip('contact@wattsonx.com')}
              onMouseLeave={() => toggleTooltip('contact@wattsonx.com')}
            />
          </span>
          <br />

          {/* Discord */}
          <span style={{ cursor: 'pointer' }}>
            <FaDiscord /> Discord: notwatty &nbsp;
            <FaCopy
              style={{ cursor: 'pointer' }}
              onClick={() => copyText('notwatty')}
              id="discordCopy"
              className="text-muted"
              onMouseEnter={() => toggleTooltip('notwatty')}
              onMouseLeave={() => toggleTooltip('notwatty')}
            />
          </span>
          <br />

          {/* Twitter */}
          <span style={{ cursor: 'pointer' }}>
            <FaTwitter /> Twitter: @wattson__x &nbsp;
            <FaShare
              style={{ cursor: 'pointer' }}
              onClick={() => window.open('https://twitter.com/wattson__x')}
              id="twitterCopy"
              className="text-muted"
              onMouseEnter={() => toggleTooltip('@wattson__x')}
              onMouseLeave={() => toggleTooltip('@wattson__x')}
            />
          </span>
        </p>
      </Col>

      {/* Tooltips */}
      <Tooltip placement="top" isOpen={tooltipOpen['contact@wattsonx.com']} target="emailCopy">
        {copyStatus['contact@wattsonx.com']}
      </Tooltip>
      <Tooltip placement="top" isOpen={tooltipOpen.notwatty} target="discordCopy">
        {copyStatus.notwatty}
      </Tooltip>
      <Tooltip placement="top" isOpen={tooltipOpen['@wattson__x']} target="twitterCopy">
        {copyStatus['@wattson__x']}
      </Tooltip>
    </Row>
  );
}

export default Contact;
